import {useTranslation} from 'react-i18next';

import * as Styled from './book-meeting-info.styles';

const BookMeetingInfo = () => {
  const {t} = useTranslation();

  return (
    <Styled.InfoContainer>
      <Styled.InfoIcon type="u_info-circle" size={20} />
      {t('modals.bookMeetingRoom.info')
        .split('.')
        .map((text, index) => {
          if (!text) return null;
          return (
            <Styled.InfoTextWithIndent type="h3" key={`text-${index}`}>
              {text}.
            </Styled.InfoTextWithIndent>
          );
        })}
    </Styled.InfoContainer>
  );
};

export default BookMeetingInfo;
